module.exports = __webpack_public_path__ + "static/media/Bagikan.105f2265.svg";